"use client";

import Text from "@/components/common/Typography/Text";
import { Button, Card, Col, Modal, Row } from "antd";
import { useTERouter } from "@/hooks/app/useTERouter";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHotel,
  faPlaneUp,
  faLocationDot,
  faSimCard,
  faPassport,
} from "@fortawesome/free-solid-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

type QuickNavVariant = "hotels" | "flights" | "tours" | "esim" | "visa";

const QuickNavigation = () => {
  const [modal, modalCtx] = Modal.useModal();
  const router = useTERouter();
  const { t } = useTranslation();

  const items: {
    key: string;
    label: string;
    icon: IconDefinition;
    variant: QuickNavVariant;
    onClick: () => void;
  }[] = [
    {
      key: "hotels",
      label: t("common.hotel"),
      icon: faHotel,
      variant: "hotels",
      onClick: () => router.push("/hotels"),
    },
    {
      key: "flights",
      label: t("common.flight"),
      icon: faPlaneUp,
      variant: "flights",
      onClick: () => router.push("/ve-may-bay"),
    },
    {
      key: "tours",
      label: "Tour",
      icon: faLocationDot,
      variant: "tours",
      onClick: () => router.push("/tours"),
    },
    {
      key: "esim",
      label: "eSIM",
      icon: faSimCard,
      variant: "esim",
      onClick: () => router.push("/esim-du-lich"),
    },
    {
      key: "visa",
      label: "Visa",
      icon: faPassport,
      variant: "visa",
      onClick: () => router.push("/dich-vu-visa"),
    },
  ];

  return (
    <Card size="small" className="home__searching--quicknav">
      {modalCtx}
      <Row wrap={false} className="home__searching--quicknav-list">
        {items.map(({ key, icon, label, variant, onClick }) => (
          <Col key={key} flex={1}>
            <Button
              onClick={onClick}
              className="home__searching--quicknav-item"
              type="text"
            >
              <span
                className={`home__searching--quicknav-icon home__searching--quicknav-icon--${variant}`}
              >
                <FontAwesomeIcon icon={icon} />
              </span>
              <Text className="home__searching--quicknav-label">{label}</Text>
            </Button>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default QuickNavigation;
